import {isNotNil} from 'ramda';

import {appWorkspaceKey} from '@dms/config';

import {Nullish} from 'shared/web';

import {applyWorkspaceHost} from './applyWorkspaceHost';

/**
 * Resolves where the workspace travels for a request: prefixed into the host when the URL can
 * carry it, otherwise as the X-Workspace header value — but only for a real tenant workspace
 * (non-nil, non-empty, not the reserved `app` redirect pseudo-workspace).
 */
export const resolveWorkspaceTarget = (url: string | undefined, workspace: string | Nullish) => {
  const baseUrl = applyWorkspaceHost(url, workspace);
  const workspaceHeader =
    baseUrl === url && isNotNil(workspace) && workspace !== '' && workspace !== appWorkspaceKey
      ? workspace
      : undefined;

  return {baseUrl, workspaceHeader};
};
